<template>
  <div>
    <v-app-bar app light fixed>
      <v-app-bar-title>
        <div style="width:450px">
          <a href="https://www.mrc-asia.com/home">
            <img
              src="@/assets/mrclogo.svg"
              alt="Management Resources Consultants"
              style="max-width:65px"
              class="mx-1"
            />
          </a>
          Executive Compensation - Public
        </div>
      </v-app-bar-title>
      <v-spacer></v-spacer>
      <SuperMenu></SuperMenu>
      <v-toolbar-items>
        <v-btn text @click="logout">
          <v-icon>exit_to_app</v-icon>
        </v-btn>
      </v-toolbar-items>
    </v-app-bar>
    <v-main>
      <router-view></router-view>
    </v-main>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import SuperMenu from '../components/SuperMenu.vue';

export default {
  methods: {
    logout() {
      fetch('/sign/out', {
        credentials: 'include',
      }).then(() => {
        window.location.href = '/sign/in?source=/exec-comp/#/public/details';
      });
    },
    ...mapActions(['querySectorsCountries']),
  },
  created() {
    this.querySectorsCountries();
  },
  components: {
    SuperMenu,
  },
};
</script>
